import { render, staticRenderFns } from "./ExternalReversal.vue?vue&type=template&id=6a9cf80e&"
import script from "./ExternalReversal.vue?vue&type=script&lang=js&"
export * from "./ExternalReversal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports